import { message } from 'antd';
import { toast } from '@rickylandino/react-messages';

export function throwError() {
    return toast.error("An error has occured.");
}

export function showSuccess() {
    toast.success("Updated Successfully");
}